import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  colors, SovosRaisedButton, SovosFlatButton, SovosDialog, SovosDialogContent
} from 's1-ui';
import TitleBar from 'pages/TitleBar';
import XIcon from 'commonComponents/xIconNoMargin';
import ChevronRight from '@material-ui/icons/ChevronRight';
import UserGuide from '../../../assets/UserGuide.pdf';
import { pageWidth } from '../../constants';

const { neutralWhite, buttonOrange, buttonBlue } = colors;

const styles = {
  container: {
    paddingTop: 60,
    maxWidth: pageWidth,
    width: 'calc(100% - 48px)',
    margin: 'auto'
  },
  title: {
    fontSize: 44,
    fontWeight: 200
  },
  text: {
    marginTop: 20,
    fontSize: 16,
    marginBottom: 30,
    display: 'flex',
    alignItems: 'center'
  },
  buttonText: {
    fontWeight: 400
  },
  urgentButton: {
    marginTop: 20
  },
  urgentLabel: {
    textTransform: 'none',
    padding: '0px',
  },
  userGuide: {
    textTransform: 'none',
    padding: '0px 5px'
  },
  dialogTitle: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: 24,
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  support: {
    marginTop: 40,
    fontSize: 16
  },
  phone: {
    marginTop: 40,
    fontSize: 20
  },
  pdf: {
    textDecoration: 'none',
    color: buttonBlue,
    marginLeft: 5,
    marginRight: 5
  }
};

export class UnstyledNeedHelp extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  };

  state = {
    dialogOpen: false
  }

  emailButtonClick = () => {
    window.location.href = 'mailto:fedexsupport@sovos.com';
  }

  render() {
    const { classes, history } = this.props;
    return (
      <div>
        <TitleBar history={ history } />
        <div className={ classes.container }>
          <div className={ classes.title }>Need a hand?</div>
          <div className={ classes.text }>
            <div>
              <ChevronRight />
            </div>
            <div>
              <span>For any questions regarding your FedEx account please reach out to your FedEx account executive.</span>
            </div>
          </div>
          <div className={ classes.text }>
            <div>
              <ChevronRight />
            </div>
            <div>
              <span>If your question is specific to utilization of the Carrier Compliance Portal, please send us an email and we will get back to you as soon as we can or download the</span>
              <span><a href={ UserGuide } className={ classes.pdf }>User Guide</a></span>
              <span>to learn more about using Carrier Compliance.</span>
            </div>
          </div>
          <div>
            <SovosRaisedButton
              color={ neutralWhite }
              backgroundColor={ buttonOrange }
              onClick={ this.emailButtonClick }
            >
              <span className={ classes.buttonText }>FedExSupport@sovos.com</span>
            </SovosRaisedButton>
          </div>
          <div className={ classes.urgentButton }>
            <SovosFlatButton
              classes={ { root: classes.urgentLabel } }
              onClick={ () => this.setState({ dialogOpen: true }) }
            >
              <span style={ { fontSize: 18, fontWeight: 400 } }>Have an urgent issue?</span>
            </SovosFlatButton>
          </div>
        </div>
        <SovosDialog
          open={ this.state.dialogOpen }
          onClose={ () => this.setState({ dialogOpen: false }) }
          width={ 400 }
        >
          <SovosDialogContent>
            <div className={ classes.dialogTitle }>
              <span>Customer Support</span>
              <XIcon
                onClick={ () => this.setState({ dialogOpen: false }) }
              />
            </div>
            <div className={ classes.support }>
              Our Support team is here to help answer any questions you may have about Carrier Compliance.
            </div>
            <div className={ classes.phone }>
              1-800-809-5988
            </div>
          </SovosDialogContent>
        </SovosDialog>
      </div>
    );
  }
}

export default withStyles(styles)(UnstyledNeedHelp);
